const stripeInstances = new Map<string, any>()
let stripeReady: Promise<void> | undefined

export const useStripeEmbeddedForm = (loadJS = false) => {
  function loadStripeFormJS(): Promise<void> {
    if (stripeReady) return stripeReady
    stripeReady = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://js.stripe.com/v3/'
      script.async = true
      script.onload = () => {
        resolve()
      }
      script.onerror = () => {
        stripeReady = undefined
        script.remove()
        reject(new Error('Failed to load Stripe.js'))
      }
      document.head.appendChild(script)
    })
    return stripeReady
  }

  async function getStripeInstance(stripePK: string) {
    await loadStripeFormJS()
    if (!stripeInstances.has(stripePK)) {
      // @ts-expect-error
      stripeInstances.set(stripePK, new window.Stripe(stripePK))
    }
    return stripeInstances.get(stripePK)
  }

  if (loadJS) {
    // Preloading is optional; getStripeInstance propagates a required load failure.
    void loadStripeFormJS().catch((error) => console.error('Stripe.js preload failed:', error))
  }

  return {
    getStripeInstance,
  }
}
